import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isFunction } from 'lodash';
import { Collapse as StrapCollapse } from 'reactstrap';
import { IconMenuDown, IconMenuRight } from '@sfx/icons';
import styles from './collapse.module.css.json';

var Panel = function Panel(props) {
  var className = props.className,
      style = props.style,
      header = props.header,
      extra = props.extra,
      canExpand = props.canExpand,
      active = props.active,
      onToggle = props.onToggle,
      activeKey = props.activeKey,
      headerClassName = props.headerClassName,
      contentClassName = props.contentClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.panel, className, {
      active: active
    }),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.header, headerClassName, _defineProperty({}, styles.disable, !canExpand)),
    onClick: function onClick() {
      canExpand && onToggle(activeKey);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, header(active)), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.extra,
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, extra(active)), canExpand && (active ? /*#__PURE__*/React.createElement(IconMenuDown, {
    className: styles.iconExpand,
    size: "28"
  }) : /*#__PURE__*/React.createElement(IconMenuRight, {
    className: styles.iconExpand,
    size: "28"
  })))), /*#__PURE__*/React.createElement(StrapCollapse, {
    isOpen: active,
    className: cx(styles.content, contentClassName),
    timeout: 0
  }, isFunction(props.children) ? props.children(active) : props.children));
};

Panel.defaultProps = {
  header: function header() {},
  extra: function extra() {},
  className: '',
  style: {},
  canExpand: true,
  headerClassName: '',
  contentClassName: ''
};
Panel.propTypes = {
  activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // correspond to the activeKey props of Collapse
  active: PropTypes.bool,
  header: PropTypes.func,
  canExpand: PropTypes.bool,
  extra: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  headerClassName: PropTypes.string,
  contentClassName: PropTypes.string
};
export default Panel;